/** Nhóm khoản chi có sẵn (KH-GĐ2 5.3.3) — mã khớp CHECK `expense_nhom_valid` của 0058. Tên hiển thị ở web quầy. */
export const NHOM_CHI_CO_SAN = [
  'vat-tu',
  'mat-bang',
  'dien-nuoc',
  'luong-hoa-hong',
  'ung-luong',
  'khac',
] as const
export type NhomChiCoSan = (typeof NHOM_CHI_CO_SAN)[number]

export function laNhomChiCoSan(x: unknown): x is NhomChiCoSan {
  return typeof x === 'string' && (NHOM_CHI_CO_SAN as readonly string[]).includes(x)
}
